import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import photovoltaikHero from "@/assets/photovoltaik-hero-efh-pv.png";
import photovoltaikPanelPlanung from "@/assets/photovoltaik-planung-haus-mit-pv.png";
import photovoltaikBeratung from "@/assets/photovoltaik-beratung-solarpanel-neu.png";
import photovoltaikBetreuung from "@/assets/photovoltaik-betreuung-efh-dach.png";
import photovoltaikReferenz from "@/assets/photovoltaik-referenz-einfamilienhaus.png";
import photovoltaikCrosslinkStromspeicher from "@/assets/photovoltaik-crosslink-stromspeicher.png";
import asset_pv_elektroinstallation_rohbau from "@/assets/pv-elektroinstallation-rohbau.jpg";
import Seo, { serviceSchema } from "@/components/feature/Seo";
export default function Photovoltaik() {
  return (
    <>
      <Seo
        title="Photovoltaik in Emmerich am Rhein | Zweering Elektrotechnik Emmerich am Rhein"
        description="Photovoltaik-Anlagen vom Elektro-Meisterbetrieb in Emmerich am Rhein und Umgebung. Planung, Installation und Service aus einer Hand — über 400 PV-Anlagen am Niederrhein."
        canonical="https://zweering.de/photovoltaik"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "Leistungen", "url": "https://zweering.de/photovoltaik"}, {"name": "Photovoltaik", "url": "https://zweering.de/photovoltaik"}]}
        schema={serviceSchema("Photovoltaik-Anlagen", "Planung, Installation und Betreuung von Photovoltaik-Anlagen für Privat, Gewerbe und Landwirtschaft in Emmerich am Rhein und Umgebung.", "https://zweering.de/photovoltaik")}
      />
      <LeistungsseiteTemplate
      enableReveal
      label="LEISTUNGEN"
      title="PHOTOVOLTAIK"
      subline="Strom vom eigenen Dach — geplant, gebaut und betreut aus einer Hand. Für Ihr Zuhause in Emmerich am Rhein und Umgebung."
      heroImage={photovoltaikHero}
      heroImageAlt="Photovoltaikanlage auf einem Einfamilienhaus in Emmerich am Rhein"
      leadText={
        <>
          Eine Photovoltaik-Anlage ist mehr als Module auf dem Dach. Sie ist der Anfang
          Ihrer <span className="text-[#4CAF50]">Energie-Unabhängigkeit</span> — wenn sie
          richtig geplant, sauber installiert und langfristig betreut wird.
        </>
      }
      panels={[
        {
          title: "BERATUNG,\nDIE ZUHÖRT",
          body: "Wir analysieren Ihr Dach, Ihren Verbrauch und Ihre Ziele — ehrlich und unverbindlich. Keine Standardpakete, sondern eine Lösung für genau Ihr Objekt.",
          image: photovoltaikBeratung,
          imageAlt: "Detailansicht von Photovoltaik-Modulen mit Wassertropfen und Wolkenreflexion in Emmerich am Rhein",
        },
        {
          title: (
            <>
              PLANUNG MIT <span className="text-[#4CAF50]">WEITBLICK</span>
            </>
          ),
          body: "Anlagengröße, Ausrichtung, Speicher, Wallbox, Wärmepumpe — wir denken Ihr Energiesystem als Ganzes, damit alle Komponenten zusammenspielen.",
          image: photovoltaikPanelPlanung,
          imageAlt: "Einfamilienhaus mit Photovoltaikanlage auf dem Dach und weißem Servicewagen in Emmerich am Rhein",
        },
        {
          title: "INSTALLATION VOM MEISTERBETRIEB",
          body: "Montage und Elektroinstallation aus einer Hand, durch unser eigenes Team. Sauber, termintreu und nach allen Normen.",
          image: asset_pv_elektroinstallation_rohbau,
          imageAlt: "Elektroinstallation im Rohbau für eine Photovoltaik-Anlage durch Zweering Elektrotechnik",
        },
        {
          title: "BETREUUNG,\nDIE BLEIBT",
          body: "Inbetriebnahme, Anmeldung, Monitoring und Service — auch nach der Installation sind wir Ihr fester Ansprechpartner.",
          image: photovoltaikBetreuung,
          imageAlt: "Einfamilienhaus mit Photovoltaik-Anlage auf dem Dach in Emmerich am Rhein",
        },
      ]}
      testimonials={allTestimonials}
      trustLine="Vertrauen unserer Kundinnen und Kunden am Niederrhein."
      packageSection={{
        headline: "ALLES IM PAKET",
        subline: "Aus einer Hand — von der Beratung bis zur Inbetriebnahme.",
        items: [
          "Premium-Module deutscher und europäischer Hersteller",
          "Wechselrichter (SMA, Fronius — Markenpartner)",
          "Stromspeicher bei Bedarf (BYD, optional)",
          "Montagesystem für Schräg- und Flachdach",
          "Komplette Elektroinstallation durch unser Team",
          "Anmeldung beim Netzbetreiber",
          "Förderantrag (KfW, BAFA)",
          "Monitoring und Inbetriebnahme",
          "Wartung und Service auf Wunsch",
        ],
        footnote:
          "Anlagengrößen von 5 kWp (Einfamilienhaus) bis 100+ kWp (Gewerbe) — wir planen, was zu Ihrem Dach und Verbrauch passt.",
      }}
      manifest={"IHR DACH.\nIHRE ENERGIE.\nIHRE ZUKUNFT."}
      caseStudy={{
        title: "PHOTOVOLTAIK FÜR EIN\u00A0EINFAMILIENHAUS",
        text: "Komplette PV-Anlage mit Speicher, installiert und betreut aus einer Hand in Emmerich am Rhein und Umgebung.",
        href: "#referenzen",
        image: photovoltaikReferenz,
        imageAlt: "Einfamilienhaus mit Photovoltaik-Anlage in Emmerich am Rhein",
      }}
      faq={[
        {
          frage: "Lohnt sich Photovoltaik in Emmerich am Rhein und Umgebung?",
          antwort:
            "Ja. Auch am Niederrhein reicht die Sonneneinstrahlung für eine wirtschaftliche Anlage — besonders in Kombination mit einem Speicher zur Eigenverbrauchsoptimierung.",
        },
        {
          frage: "Wie lange dauert die Installation?",
          antwort:
            "Die reine Montage dauert meist 1-2 Tage. Von Beratung bis Inbetriebnahme planen wir den Zeitrahmen gemeinsam mit Ihnen.",
        },
        {
          frage: "Kümmern Sie sich um die Anmeldung?",
          antwort:
            "Ja, Netzanmeldung und alle Formalitäten übernehmen wir für Sie — aus einer Hand.",
        },
        {
          frage: "Kann ich später einen Speicher oder eine Wallbox ergänzen?",
          antwort:
            "Wir planen Ihre Anlage von Anfang an erweiterbar, damit Speicher, Wallbox oder Wärmepumpe später problemlos dazukommen.",
        },
      ]}
      ctaText={{
        headline: "BEREIT FÜR IHRE EIGENE ENERGIE?",
        subtext: "Kostenlose, unverbindliche Erstberatung — wir schauen uns Ihr Dach an.",
        buttonLabel: "Erstberatung anfragen",
        buttonHref: "/kontakt",
        variant: "green",
      }}
      crossLink={{
        title: "STROMSPEICHER",
        text: "Machen Sie Ihren Solarstrom rund um die Uhr nutzbar.",
        href: "/stromspeicher",
        image: photovoltaikCrosslinkStromspeicher,
        imageAlt: "Moderner Stromspeicher und Wechselrichter im Keller einer Photovoltaik-Anlage in Emmerich am Rhein",
      }}
    />
    </>
  );
}
